// extracted by mini-css-extract-plugin
export default {"mixlr-footer":"styles_mixlr-footer__OREly"};